import TCalendar from './calendar.vue'
export default TCalendar



// WEBPACK FOOTER //
// ./src/components/calendar/index.js